import styled from 'styled-components';

const DivInputComment = styled.div`
  border: 1px solid var(--on-background);
  border-radius: 4px;
  margin: 10px 0;
  min-height: 100px;
  padding: 8px;
`;

export default DivInputComment;
